/* eslint-disable max-lines */
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { setSubscriptionSelectedPage } from '../../../../../../redux/actions'

import { getLazyLoadingDummyPage } from './sub-pages/lazy-loading-dummy'
import { RmaPage } from './sub-pages/rma-page'
import { SubscriptionMenuPage } from './sub-pages/subscription-menu'
import { WebfleetSubscriptionsPageConnected } from './sub-pages/wf-subscription-page/wf-subscription-page-connected'

export const SubscriptionPageHandler = ({ activeStep, intl, setPagerFunctions, setStep, steps }) => {
    const dispatch = useDispatch()

    const fetchProcessSuccess = useSelector(state => state.fetchProcessSuccess.fetchProcessSuccess)
    const subscriptionSelectedPage = useSelector(state => state.subscriptionSelectedPage.subscriptionSelectedPage)
    const selectedSubscriptionOption = useSelector(state => state.selectedSubscriptionOption.selectedSubscriptionOption)

    const setSelectedPage = selectedPage => {
        dispatch(setSubscriptionSelectedPage(selectedPage))
    }

    const pagesHandler = () => {
        if (!selectedSubscriptionOption) {
            return (
                <SubscriptionMenuPage
                    {...{
                        activeStep,
                        intl,
                        pageSelectedOption: subscriptionSelectedPage,
                        setPagerFunctions,
                        setSelectedPage,
                        setStep,
                        steps
                    }}
                />
            )
        }

        if (subscriptionSelectedPage === 'wfsubscription') {
            return <WebfleetSubscriptionsPageConnected {...{ activeStep, intl, setPagerFunctions, setStep, steps }} />
        }

        if (subscriptionSelectedPage === 'rma') {
            return <RmaPage {...{ activeStep, intl, setPagerFunctions, setStep, steps }} />
        }
    }

    return fetchProcessSuccess ? pagesHandler() : getLazyLoadingDummyPage()
}
